import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';

import i18n from '../../i18n/i18n';
import { logout, setBanNotice } from '../../store/auth/authActions';
import { authSessionEvents } from '../helpers/authSessionEvents';
import { clearAuthFromStorage } from '../helpers/authStorage';
import { navigationRef } from '../helpers/navigationService';
import { toast } from '../helpers/toastUtils';

const getDefaultSessionMessage = () =>
	i18n.t('T_SITE_SESSION_ENDED_OTHER_DEVICE', {
		defaultValue: 'Your session ended because you logged in on another device.',
	});
const DEFAULT_BAN_MESSAGE = 'Your account has been suspended.';

export function useAuthSessionInvalidation() {
	const dispatch = useDispatch();
	const isHandlingRef = useRef(false);

	useEffect(() => {
		return authSessionEvents.subscribe(payload => {
			if (isHandlingRef.current) {
				return;
			}

			isHandlingRef.current = true;
			clearAuthFromStorage();
			dispatch(logout());

			if (navigationRef.isReady()) {
				navigationRef.resetRoot({
					index: 0,
					routes: [{ name: 'Main' }],
				});
			}

			if (payload.reason === 'banned') {
				// The moderation service revoked the session; show the suspension screen instead of
				// the "logged in elsewhere" toast.
				dispatch(
					setBanNotice({
						code: payload.expiresAt
							? 'T_AUTH_LOGIN_ACCOUNT_BANNED_UNTIL'
							: 'T_AUTH_LOGIN_ACCOUNT_BANNED',
						message: payload.message || DEFAULT_BAN_MESSAGE,
						expiresAt: payload.expiresAt ?? null,
						reason: payload.banReason,
					}),
				);
			} else {
				toast.errorText(payload.message || getDefaultSessionMessage());
			}

			setTimeout(() => {
				isHandlingRef.current = false;
			}, 1000);
		});
	}, [dispatch]);
}
